import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Button } from './ui/Button';
const comparisonData = [{
  feature: 'Lesson Idea Sharing',
  nexio: true,
  email: false,
  forms: 'partial',
  lms: false,
  drive: false,
  description: 'Collect and organize teaching ideas from your community'
}, {
  feature: 'Resource Library',
  nexio: true,
  email: false,
  forms: false,
  lms: 'partial',
  drive: 'partial',
  description: 'Centralized hub for study materials and teaching resources'
}, {
  feature: 'Peer Feedback',
  nexio: true,
  email: false,
  forms: false,
  lms: false,
  drive: false,
  description: 'Structured feedback system for educators and students'
}, {
  feature: 'Transparent Status',
  nexio: true,
  email: false,
  forms: false,
  lms: 'partial',
  drive: false,
  description: 'Track submission status and collaboration progress'
}, {
  feature: 'Team Collaboration',
  nexio: true,
  email: false,
  forms: false,
  lms: 'partial',
  drive: 'partial',
  description: 'Work together on curriculum and lesson planning'
}];
export function Comparison() {
  return <section id="comparison" className="py-20 bg-white" data-id="element-67">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
        <div className="text-center mb-16" data-id="element-69">
          <span className="inline-block px-4 py-1 bg-[#F0F9F4] text-[#00A862] text-sm font-medium rounded-full mb-4 border border-[#00A862] shadow-sm" data-id="element-70">
            Comparison
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-71">
            Why educators choose Nexio
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-72">
            Purpose-built for educational collaboration, not just generic file
            storage or communication tools.
          </p>
        </div>
        <div className="overflow-x-auto rounded-lg shadow-md border-2 border-[#00A862]" data-id="element-73">
          <table className="w-full min-w-[800px] border-collapse" data-id="element-74">
            <thead data-id="element-75">
              <tr className="bg-gray-50" data-id="element-76">
                <th className="py-4 px-6 text-left text-gray-500 font-medium border border-[#00A862] bg-gray-100" data-id="element-77">
                  Feature
                </th>
                <th className="py-4 px-6 text-center text-[#00A862] font-semibold bg-green-50 border border-[#00A862]" data-id="element-78">
                  Nexio App
                </th>
                <th className="py-4 px-6 text-center text-gray-500 font-medium border border-[#00A862] bg-gray-100" data-id="element-79">
                  Email
                </th>
                <th className="py-4 px-6 text-center text-gray-500 font-medium border border-[#00A862] bg-gray-100" data-id="element-80">
                  Google Forms
                </th>
                <th className="py-4 px-6 text-center text-gray-500 font-medium border border-[#00A862] bg-gray-100" data-id="element-81">
                  LMS
                </th>
                <th className="py-4 px-6 text-center text-gray-500 font-medium border border-[#00A862] bg-gray-100" data-id="element-82">
                  Google Drive
                </th>
              </tr>
            </thead>
            <tbody data-id="element-83">
              {comparisonData.map((row, index) => <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} data-id="element-84">
                  <td className="py-4 px-6 border border-[#00A862] bg-white shadow-sm" data-id="element-85">
                    <div data-id="element-86">
                      <p className="font-medium text-gray-900" data-id="element-87">{row.feature}</p>
                      <p className="text-sm text-gray-500" data-id="element-88">{row.description}</p>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-center border border-[#00A862] bg-green-50 shadow-sm" data-id="element-89">
                    {row.nexio === true && <CheckIcon className="mx-auto text-[#00A862]" size={20} data-id="element-90" />}
                    {row.nexio === false && <XIcon className="mx-auto text-red-500" size={20} data-id="element-91" />}
                    {row.nexio === 'partial' && <div className="mx-auto w-5 h-5 rounded-full bg-yellow-400" data-id="element-92"></div>}
                  </td>
                  <td className="py-4 px-6 text-center border border-[#00A862] bg-white shadow-sm" data-id="element-93">
                    {row.email === true && <CheckIcon className="mx-auto text-green-500" size={20} data-id="element-94" />}
                    {row.email === false && <XIcon className="mx-auto text-red-500" size={20} data-id="element-95" />}
                    {row.email === 'partial' && <div className="mx-auto w-5 h-5 rounded-full bg-yellow-400" data-id="element-96"></div>}
                  </td>
                  <td className="py-4 px-6 text-center border border-[#00A862] bg-white shadow-sm" data-id="element-97">
                    {row.forms === true && <CheckIcon className="mx-auto text-green-500" size={20} data-id="element-98" />}
                    {row.forms === false && <XIcon className="mx-auto text-red-500" size={20} data-id="element-99" />}
                    {row.forms === 'partial' && <div className="mx-auto w-5 h-5 rounded-full bg-yellow-400" data-id="element-100"></div>}
                  </td>
                  <td className="py-4 px-6 text-center border border-[#00A862] bg-white shadow-sm" data-id="element-101">
                    {row.lms === true && <CheckIcon className="mx-auto text-green-500" size={20} data-id="element-102" />}
                    {row.lms === false && <XIcon className="mx-auto text-red-500" size={20} data-id="element-103" />}
                    {row.lms === 'partial' && <div className="mx-auto w-5 h-5 rounded-full bg-yellow-400" data-id="element-104"></div>}
                  </td>
                  <td className="py-4 px-6 text-center border border-[#00A862] bg-white shadow-sm" data-id="element-105">
                    {row.drive === true && <CheckIcon className="mx-auto text-green-500" size={20} data-id="element-106" />}
                    {row.drive === false && <XIcon className="mx-auto text-red-500" size={20} data-id="element-107" />}
                    {row.drive === 'partial' && <div className="mx-auto w-5 h-5 rounded-full bg-yellow-400" data-id="element-108"></div>}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-6 mt-16" data-id="element-109">
          <Button size="lg" className="min-w-[180px] shadow-md" href="https://nexioapp.eu/dashboard/register" data-id="element-110">
            Start your free trial
          </Button>
          <Button variant="outline" size="lg" className="min-w-[180px]" href="https://calendar.app.google/6fKsGXEmBQzjPvnc9" data-id="element-111">
            Schedule a Demo
          </Button>
        </div>
      </div>
    </section>;
}